import intl from "react-intl-universal";
import { TbAlertTriangle } from "react-icons/tb";

const DEFAULT_STYLES = {
  development:
    "bg-amber-50 text-amber-700 dark:bg-amber-950/40 dark:text-amber-300",
  production:
    "bg-emerald-50 text-emerald-700 dark:bg-emerald-950/40 dark:text-emerald-300",
};

const MINIMAL_STYLES = {
  development:
    "border border-dashed border-gray-300 bg-transparent text-gray-500 dark:border-gray-600 dark:text-gray-400",
  production:
    "border border-gray-200 bg-transparent text-brand-dark dark:border-brand-dark-border dark:text-gray-100",
};

export const BaasInstanceEnvironmentBadge = ({
  environment,
  className = "",
  variant = "default",
}) => {
  const isMinimal = variant === "minimal";
  const styles = isMinimal ? MINIMAL_STYLES : DEFAULT_STYLES;
  const isDevelopment = environment === "development";

  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-[11px] font-medium ${styles[environment] ?? styles.development} ${className}`}
    >
      {isMinimal ? (
        isDevelopment ? (
          <TbAlertTriangle className="h-3 w-3 shrink-0 opacity-70" aria-hidden />
        ) : (
          <span
            className="h-1.5 w-1.5 shrink-0 rounded-full bg-emerald-500"
            aria-hidden
          />
        )
      ) : null}
      {intl.get(`baas.instances.environment.${environment}`)}
    </span>
  );
};
